import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteAdmin2FANumber: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `v4/admins/${id}/2fa-phoneNumber`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const { useDeleteAdmin2FANumberMutation } = apiSlice;
